export default function isDateInRange(itemDate: string | Date, dateRange: (Date | null)[]) {
    if (!dateRange[0] || !dateRange[1]) return true;

    const testDate = typeof itemDate === 'string' ? new Date(itemDate) : itemDate;

    if (
        (!dateRange?.[0] && !dateRange?.[1]) ||
        (testDate.getTime() >= new Date(dateRange?.[0]).setHours(0, 0, 0, 0) &&
            testDate.getTime() <= new Date(dateRange?.[1]).setHours(23, 59, 59, 999))
    ) {
        return true;
    }

    return false;
}
